/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */
(function ($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
                /* ===== Logic for creating fake Select Boxes ===== */
                $('.sel').each(function () {
                    $(this).children('select').css('display', 'none');

                    var $current = $(this);

                    $(this).find('option').each(function (i) {
                        if (i == 0) {
                            $current.prepend($('<div>', {
                                class: $current.attr('class').replace(/sel/g, 'sel__box')
                            }));

                            var placeholder = $(this).text();
                            $current.prepend($('<span>', {
                                class: $current.attr('class').replace(/sel/g, 'sel__placeholder'),
                                text: placeholder,
                                'data-placeholder': placeholder
                            }));

                            return;
                        }

                        $current.children('div').append($('<span>', {
                            class: $current.attr('class').replace(/sel/g, 'sel__box__options'),
                            text: $(this).text()
                        }));
                    });
                });

                $(".header-contact .button").click(function () {
                    return $("html, body").animate({scrollTop: $("#p41bar-contact").offset().top}, 2000, 'swing', 'easeOutExpo');
                });

                // Toggling the `.active` state on the `.sel`.
                $('.sel').click(function () {
                    $(this).toggleClass('active');
                });

                // Toggling the `.selected` state on the options.
                $('.sel__box__options').click(function () {
                    var txt = $(this).text();
                    var index = $(this).index();

                    $(this).siblings('.sel__box__options').removeClass('selected');
                    $(this).addClass('selected');

                    var $currentSel = $(this).closest('.sel');
                    $currentSel.children('.sel__placeholder').text(txt);
                    $currentSel.children('.sel__placeholder').attr('data-placeholder', txt);
                    $currentSel.children('select').prop('selectedIndex', index + 1);

                    location.href = $("#select-lang").val();
                });

                // $('.eventos-list').slick({
                //     infinite: false,
                //     slidesToShow: 3,
                //     slidesToScroll: 3,
                //     arrows: false,
                //     centerMode: false,
                //     variableWidth: true,
                //     responsive: [
                //         {
                //             breakpoint: 769,
                //             settings: {
                //                 centerMode: true,
                //                 slidesToShow: 1,
                //                 slidesToScroll: 1,
                //             }
                //         }
                //     ]
                // });

                // // Get the current slide
                // var $currentSlide = $('.eventos-list').slick('slickCurrentSlide');

                // // On before slide change
                // $('.eventos-list').on('afterChange', function(event, slick, currentSlide, nextSlide){
                //     if (currentSlide < 3){
                //         $('.eventos-flechas .left').css('display', 'none');
                //     } else {
                //         $('.eventos-flechas .left').css('display', 'flex');
                //     }
                // });

                $('.menciones-list').slick({
                    infinite: true,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    arrows: false,
                    responsive: [
                        {
                            breakpoint: 769,
                            settings: {
                                slidesToShow: 1,
                                slidesToScroll: 1,
                            }
                        }
                    ]
                });

                /**** ANIMATIONS ****/
                $('.appear_element').appear();
                var allAppearElements = $('.appear_element');
                allAppearElements.each(function () {
                    if ($(this).is(':appeared')) $(this).addClass('show');
                })

                $(document.body).on('appear', '.appear_element', function (e, $affected) {
                    $affected.each(function () {
                        $(this).addClass('show');
                    })
                });

                /****** MOBILE MENU *****/
                var isMobile = false; //initiate as false
                // device detection
                if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
                    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) {
                    isMobile = true;
                }

                if (isMobile) {
                    $('#menu').css({
                        'height': '100vh',
                        'padding-top': '10vh',
                    });
                    var liHeight = $(window).height() * 0.9 / 7;
                    var textHeight = liHeight - 20;
                    var textWidth = $(window).width() / 14;
                    var textSize = (textHeight < textWidth) ? textHeight : textWidth;
                    var liHeightCss = liHeight + 'px';
                    var fontSizeLi = textSize + 'px';

                    $('#menu .menu-link-a li').css({
                        'height': liHeightCss,
                        'padding': '10px 0',
                        'font-size': fontSizeLi,
                        'line-height': fontSizeLi,
                    });

                    $('#menu .menu-link-a').css({
                        'display': 'block',
                    });
                    $('#menu .menu-link-a li').css({
                        'display': 'table-cell',
                        'vertical-align': 'middle',
                    });
                }

            },
            finalize: function () {
                // JavaScript to be fired on all pages, after page specific JS is fired
                $('.menu-link-a').on('click', function (e) {
                    $('#menuToggle input').prop("checked", false);
                });

                $("#checkbox-conditions-custom").click(function () {
                    0 == $("#checkbox-conditions").is(":checked") ? $("#checkbox-conditions").prop("checked", !0) : $("#checkbox-conditions").prop("checked", !1)
                }), $("#mc-embedded-subscribe-form").validate({
                    rules: {
                        FNAME: {required: !0, minlength: 2},
                        EMAIL: {required: !0, email: !0},
                        CONDITIONS: {required: !0}
                    },
                    messages: {
                        FNAME: {
                            required: "El nombre es obligatorio",
                            minlength: jQuery.validator.format("El nombre introducido no es válido.")
                        },
                        EMAIL: {
                            required: "El correo electrónico es obligatorio.",
                            email: jQuery.validator.format("El email introducido no es válido.")
                        },
                        CONDITIONS: {required: "Debe aceptar la Política de Privacidad."}
                    },
                    errorPlacement: function (e, o) {
                        "CONDITIONS" === o.attr("name") ? e.insertAfter(".fieldset-conditions .checkbox-conditions-content") : e.insertAfter(o)
                    },
                    submitHandler: function (e) {
                        $.post("/app/themes/p41bar/subscribe.php", {
                            FNAME: $("#mce-FNAME").val(),
                            EMAIL: $("#mce-EMAIL").val()
                        }, function (e) {
                            $(".box-form").html(e)
                        })
                    }
                });

                $("#checkbox-promo-custom-ko").click(function () {
                    0 == $("#checkbox-conditions-ko").is(":checked") ? $("#checkbox-conditions-ko").prop("checked", !0) : $("#checkbox-conditions-ko").prop("checked", !1)
                });

                $("#checkbox-promo-custom-ok").click(function () {
                    0 == $("#checkbox-conditions-ok").is(":checked") ? $("#checkbox-conditions-ok").prop("checked", !0) : $("#checkbox-conditions-ok").prop("checked", !1)
                });

                $("#mc-embedded-event-form").validate({
                    rules: {
                        FNAME: {required: !0, minlength: 2},
                        FSURNAME: {required: !0, minlength: 2},
                        FEMAIL: {required: !0, email: !0},
                        FTELF: {required: !0, minlength: 2},
                        FPAX: {required: !0, minlength: 2}
                    },
                    messages: {
                        FNAME: {
                            required: "El nombre es obligatorio",
                            minlength: jQuery.validator.format("El nombre introducido no es válido.")
                        },
                        FSURNAME: {
                            required: "El nombre es obligatorio",
                            minlength: jQuery.validator.format("El nombre introducido no es válido.")
                        },
                        FEMAIL: {
                            required: "El correo electrónico es obligatorio.",
                            email: jQuery.validator.format("El email introducido no es válido.")
                        },
                        FTELF: {
                            required: "El nombre es obligatorio",
                            minlength: jQuery.validator.format("El nombre introducido no es válido.")
                        },
                        FPAX: {
                            required: "El nombre es obligatorio",
                            minlength: jQuery.validator.format("El nombre introducido no es válido.")
                        },
                        CONDITIONS: {required: "Debe aceptar la Política de Privacidad."}
                    },
                    errorPlacement: function (e, o) {
                        "CONDITIONS" === o.attr("name") ? e.insertAfter(".fieldset-conditions .checkbox-conditions-content") : e.insertAfter(o)
                    },
                    submitHandler: function (e) {
                        $.post("/app/themes/p41bar/subscribe.php", {
                            FNAME: $("#mce-FNAME").val(),
                            EMAIL: $("#mce-EMAIL").val()
                        }, function (e) {
                            $(".box-form").html(e)
                        })
                    }
                });
            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'about_us': {
            init: function () {
                // JavaScript to be fired on the about us page
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.


// function prevEventSlide() {
//     jQuery('.eventos-list').slick("slickPrev");
// }

// function nextEventSlide() {
//     jQuery('.eventos-list').slick("slickNext");
// }

function prevMentionSlide() {
    jQuery('.menciones-list').slick("slickPrev");
}

function nextMentionSlide() {
    jQuery('.menciones-list').slick("slickNext");
}
